<template>
  <div class="tenant-card" @click="handleClick">
    <div class="logo-container">
      <org-avatar
        class="avatar-img"
        :orgName="data.name"
        :iconUrl="data.logoUrl"
      ></org-avatar>
    </div>
    <div class="tenant-container">
      <div class="tenant-name text-ellipsis">
        {{ data.name }}
      </div>
      <div class="version-info text-ellipsis">
        {{ tenant.versionId }}&nbsp;{{ tenant.expirationTime }}{{ $t('profile.tenant.oufOfDate') }}
      </div>
    </div>
  </div>
</template>

<script>
import OrgAvatar from '@/components/org-avatar'
export default {
  components: {
    OrgAvatar
  },
  props: {
    data: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    // loadLogo() {
    //   return this.data.logoUrl || require('../../assets/logo-sq.png')
    // },
    tenant() {
      return this.data.tenantBasicInfo || {}
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.tenant-card {
  display: flex;
  height: 5.143rem;
  width: 100%;
  //margin: 0.571rem 0;
  box-sizing: border-box;
  border-bottom: 1px solid $--app-split-line-color;
  padding: 1.14rem;
  background: $--app-light-color;
  .logo-container {
    width: 2.86rem;
    height: 2.86rem;
    flex: 0 0 2.86rem;
    padding-right: 1.14rem;
    .tenant-logo {
      width: 100%;
      height: 100%;
    }
  }
  .tenant-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow: hidden;
    margin-top: .1457rem;
    .tenant-name {
      height: 1.143rem;
    }
    .version-info {
      margin-top: 0.571rem;
      color: $--app-notice-color;
      font-size: .857rem;
    }
  }
}
</style>
